import 'react-select/dist/react-select.css';
import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'components/payment/actions';
import { selectCard } from './actions';
import Select from 'react-select';
import Modal from 'react-modal';
import PaymentMethodForm from '../payment/form';
import CardLogoList from '../payment/logoList';

class BartenderPayment extends React.Component {
  constructor() {
    super();
    this.state = { selected: null, showModal: false };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.select = this.select.bind(this);
    this.onPaymentSuccess = this.onPaymentSuccess.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const prevCards = this.props.cards || [];
    const nextCards = nextProps.cards || [];
    if (prevCards.length !== nextCards.length) {
      if (nextCards[0]) this.select(nextCards[0]);
    }
  }

  openModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  select(item) {
    this.setState({ selected: item });
    this.props.selectCard(item.id);
  }

  onPaymentSuccess(card) {
    this.setState({ selected: card });
    this.props.selectCard(card.id);
    this.closeModal();
  }

  render() {
    this.selected = this.state.selected || this.props.cards[0];
    return (
      <div className="checkout-payment">
        <Select
          clearable={false}
          searchable={false}
          value={this.selected}
          valueRenderer={this.renderOption.bind(this)}
          options={this.props.cards}
          optionRenderer={this.renderOption.bind(this)}
          onChange={this.select}
        />
        <span
          className="link-text checkout-payment-add"
          onClick={this.openModal}
        >
          Add Credit Card
        </span>

        <Modal
          overlayClassName="modal-overlay"
          className="modal-content"
          isOpen={this.state.showModal}
          onRequestClose={this.closeModal}
          shouldCloseOnOverlayClick={true}
          contentLabel="Payment Info"
          ariaHideApp={false}
        >
          <div className="payment-modal__container">
            <div className="clearfix">
              <CardLogoList className="right" />
              <h2 className="payment-modal__header">Payment Info</h2>
            </div>
            <PaymentMethodForm
              onSuccess={this.onPaymentSuccess}
              cardInputClass="form-field stripe-input-container"
              btnContainerClass="col-xs-12"
              btnClass="btn-primary btn--full-width"
            />
          </div>
        </Modal>
      </div>
    );
  }

  renderOption(item) {
    let className = [
      'checkout-payment-card',
      item.brand.toLowerCase().replace(' ', '-')
    ].join(' ');
    return <div className={className}>Ends in {item.last4}</div>;
  }
}

function mapStateToProps(state) {
  return { ...state.payment };
}

export default connect(mapStateToProps, { ...actions, selectCard })(
  BartenderPayment
);



// WEBPACK FOOTER //
// ./shared/components/bartender/payment.js